<template>
  <div id="Sep2023" class="202309">
    <main class="main mx-auto">
      <!-- banner -->
      <section id="section1" class="section1 py-4 md:py-10 dot-bg">
        <div class="flex justify-center w-full mb-6 max-w-7xl mx-auto px-2">
          <div><img src="~@/assets/images/202309/source_main-tit.png" class="object-contain block"></div>
        </div>
      </section>
      <!-- 四格活動 -->
      <section id="section2" class="section2 py-10 main-bg">
        <div class="flex items-center justify-center max-w-7xl mx-auto px-2">
          <div class=""><img src="~@/assets/images/202309/source_main-con03.png" class="object-contain block"></div>
          <div class="relative">
            <div><img src="~@/assets/images/202309/source_main-con01.png" class="object-contain block"></div>
            <div class="absolute section2_sale"><img src="~@/assets/images/202309/source_main-con02.png" class="object-contain block"></div>
          </div>
          <div class=""><img src="~@/assets/images/202309/source_main-con04.png" class="object-contain block"></div>
        </div>
      </section>
      <!-- 開學好康1 -->
      <section id="section3" class="section3 py-10 main-bg px-2 md:px-8">
        <div class="container bg-white pt-20 pb-4 px-2 md:p-16 lg:px-48 relative">
          <div class="absolute p1"><img src="~@/assets/images/202309/source_gf-01.png" class="object-contain mx-auto w-10/12 md:w-11/12"></div>
          <div class=""><img src="~@/assets/images/202309/source_gf-con.png" class="object-contain block"></div>
          <div class="absolute p2"><img src="~@/assets/images/202309/source_gf-02.png" class="object-contain mx-auto"></div>
          <div class="absolute p3"><img src="~@/assets/images/202309/source_gf-03.png" class="object-contain mx-auto"></div>
        </div>
      </section>
      <!-- 鉛筆小孩 -->
      <section id="section4" class="section4 dot-bg">
        <div class="container relative">
          <div class="mx-auto"><img src="~@/assets/images/202309/source_mg-01.png" class="object-contain mx-auto"></div>
        </div>
      </section>
      <!-- 開學好康2 -->
      <section id="section5" class="section5 main-bg pb-40">
        <div class="container bg-white pt-10">
          <div class="px-4 md:px-24">
            <div class="mx-auto px-12"><img src="~@/assets/images/202309/source_mg-02.png" class="object-contain mx-auto w-10/12 md:w-11/12"></div>
            <div class="mx-auto"><img src="~@/assets/images/202309/source_mg-03.png" class="object-contain mx-auto"></div>
            <div class="mx-auto md:w-9/12"><img src="~@/assets/images/202309/source_mg-04.png" class="object-contain mx-auto"></div>

            <div class="flex flex-wrap">
              <div class="p-4" :class="item.widthP" v-for="(item, index) in planData" :key="index"><img :src="item.img_url" class="object-contain mx-auto"></div>
            </div>
          </div>
          <div class="relative w-full mt-24">
            <a class="box-center" href="https://store.liveabc.com/products/magazine/sale?tag=262" target="_blank"><img src="~@/assets/images/202309/source_mg-sub.png" class="object-contain w-auto md:w-8/12 mx-auto"></a>
            <div><img src="~@/assets/images/202309/source_mian-line.png" class="object-contain mx-auto"></div>
          </div>
        </div>
      </section>
      <!-- 開學好康3 -->
      <section id="section6" class="section6 main-bg pb-24 relative">
        <div class="absolute p1"><img src="~@/assets/images/202309/source_book-con01.png" class="object-contain"></div>
        <div class="container bg-white pt-16">
          <div class="px-4 md:px-12 mb-4">
            <div class="mx-auto md:px-6 "><img src="~@/assets/images/202309/source_book-con02.png" class="object-contain mx-auto"></div>
            <div class="mx-auto md:px-6"><img src="~@/assets/images/202309/source_book-con03.png" class="object-contain mx-auto"></div>
          </div>
          <div class="mx-auto mb-4"><img src="~@/assets/images/202309/source_mian-line3.png" class="object-contain mx-auto"></div>

          <div class="flex flex-wrap ">
            <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }" class="w-1/2 md:w-1/4 p-4" target="_blank" v-for="(item, index) in bookData1" :key="index">
              <img :src="item.img_url" class="object-contain mx-auto">
            </router-link>
          </div>

          <div class="relative w-full mt-10">
            <a class="box-center" href="https://store.liveabc.com/products/magazine/sale?tag=280" target="_blank"><img src="~@/assets/images/202309/source_book-bt-more.png" class="object-contain w-auto md:w-8/12 mx-auto"></a>
            <div><img src="~@/assets/images/202309/source_mian-line.png" class="object-contain mx-auto"></div>
          </div>
        </div>
      </section>
      <!-- 3件75折 -->
      <section id="section7" class="section7 py-20 second-bg">
        <div class="container bg-white">
          <div class="relative w-full mb-10">
            <div class="box-center"><img src="~@/assets/images/202309/source_sw-con01.png" class="object-contain"></div>
            <div><img src="~@/assets/images/202309/source_mian-line.png" class="object-contain mx-auto"></div>
          </div>
          <div class="flex justify-items-center items-center px-4 md:px-16">
            <div class="mx-auto"><img src="~@/assets/images/202309/source_sw-con02.png" class="object-contain"></div>
            <div class="mx-auto"><img src="~@/assets/images/202309/source_sw-con03.png" class="object-contain"></div>
          </div>
          <div class="flex items-center justify-center py-6 px-4 md:px-16">
            <div class="mx-auto"><img src="~@/assets/images/202309/source_sw-con05.png" class="object-contain"></div>
            <div class="mx-auto"><img src="~@/assets/images/202309/source_sw-con04.png" class="object-contain"></div>
            <div class="mx-auto"><img src="~@/assets/images/202309/source_sw-con06.png" class="object-contain"></div>
          </div>

          <div class="flex flex-wrap">
            <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }" class="w-1/2 md:w-1/4 p-4" target="_blank" v-for="(item, index) in bookData2" :key="index">
              <img :src="item.img_url" class="object-contain mx-auto">
            </router-link>
          </div>

          <div class="flex justify-center items-center px-2 lg:px-24 py-4 lg:py-10">
            <div class="mx-auto mt-6"><img src="~@/assets/images/202309/source_sw-at01.png" class="object-contain mx-auto"></div>
            <div class="mx-auto mt-6"><img src="~@/assets/images/202309/source_sw-at02.png" class="object-contain mx-auto"></div>
          </div>

          <div class="relative w-full mt-10">
            <a class="box-center" href="https://store.liveabc.com/products/magazine/sale?tag=281" target="_blank"><img src="~@/assets/images/202309/source_sw-bt-more.png" class="object-contain w-auto md:w-8/12 mx-auto"></a>
            <div><img src="~@/assets/images/202309/source_mian-line3.png" class="object-contain mx-auto"></div>
          </div>
        </div>
      </section>
      <!-- footer -->
      <section id="section8" class="section8 py-10 dot-bg px-2 sm:px-6">
        <div class="max-w-7xl mx-auto relative">
          <div class="mx-auto"><img src="~@/assets/images/202309/source_at01.png" class="object-contain"></div>
          <div class="absolute p4"><img src="~@/assets/images/202309/source_at02.png" class="object-contain"></div>
        </div>
      </section>
    </main>
  </div>
</template>
<script>
import jump from 'jump.js'
import axios from 'axios'
export default {
  name: 'May2023',
  metaInfo () {
    return {
      title: '開學囉! 收心操預備備!LiveABC開學書展強勢登場',
      titleTemplate: null
    }
  },
  data () {
    return {
      isMenu: false,
      renderComponent: false,
      planData: [
        { name: 'HW', id: 8640, grade: '圖解｜百科｜符合108課綱', title: '知識大圖解', type: 'hiw', img_url: require('@/assets/images/202309/HIW-COVER.png'), widthP: 'w-1/2' },
        { name: 'ABC', id: 8635, grade: '初級｜基礎｜活用', title: 'ABC互動英語', type: 'abc', img_url: require('@/assets/images/202309/ABC-COVER.png'), widthP: 'w-1/2' },
        { name: 'LIVE', id: 8637, grade: '中級｜生活｜實用', title: 'Live互動英語', img_url: require('@/assets/images/202309/Live-COVER.png'), widthP: 'w-1/2 md:w-1/4' },
        { name: 'ALL', id: 8638, grade: '中高級｜進階｜應用', title: 'ALL+互動英語', img_url: require('@/assets/images/202309/ALL-COVER.png'), widthP: 'w-1/2 md:w-1/4' },
        { name: 'CNN', id: 8639, grade: '新聞｜時事｜新知', title: 'CNN互動英語', type: 'cnn', img_url: require('@/assets/images/202309/CNN-COVER.png'), widthP: 'w-1/2 md:w-1/4' },
        { name: 'JP', id: 8641, grade: '初級｜生活｜實用', title: '互動日本語', type: 'jp', img_url: require('@/assets/images/202309/JP-COVER.png'), widthP: 'w-1/2 md:w-1/4' }
      ],

      bookData1: [
        { id: 7694, img_url: require('@/assets/images/202309/source_book-item1.png') },
        { id: 7549, img_url: require('@/assets/images/202309/source_book-item2.png') },
        { id: 6935, img_url: require('@/assets/images/202309/source_book-item3.png') },
        { id: 7548, img_url: require('@/assets/images/202309/source_book-item4.png') },
        { id: 8588, img_url: require('@/assets/images/202309/source_book-item5.png') },
        { id: 8502, img_url: require('@/assets/images/202309/source_book-item6.png') },
        { id: 7399, img_url: require('@/assets/images/202309/source_book-item7.png') },
        { id: 7873, img_url: require('@/assets/images/202309/source_book-item8.png') },
        { id: 8214, img_url: require('@/assets/images/202309/source_book-item9.png') },
        { id: 7231, img_url: require('@/assets/images/202309/source_book-item10.png') },
        { id: 7287, img_url: require('@/assets/images/202309/source_book-item11.png') },
        { id: 7801, img_url: require('@/assets/images/202309/source_book-item12.png') },
        { id: 8587, img_url: require('@/assets/images/202309/source_book-item13.png') },
        { id: 8464, img_url: require('@/assets/images/202309/source_book-item14.png') },
        { id: 8167, img_url: require('@/assets/images/202309/source_book-item15.png') },
        { id: 7582, img_url: require('@/assets/images/202309/source_book-item16.png') }
      ],
      bookData2: [
        { id: 8803, img_url: require('@/assets/images/202309/source_sw-item1.png') },
        { id: 8800, img_url: require('@/assets/images/202309/source_sw-item2.png') },
        { id: 8473, img_url: require('@/assets/images/202309/source_sw-item3.png') },
        { id: 8629, img_url: require('@/assets/images/202309/source_sw-item4.png') },
        { id: 8631, img_url: require('@/assets/images/202309/source_sw-item5.png') },
        { id: 8141, img_url: require('@/assets/images/202309/source_sw-item6.png') },
        { id: 7503, img_url: require('@/assets/images/202309/source_sw-item7.png') },
        { id: 8744, img_url: require('@/assets/images/202309/source_sw-item8.png') }
      ]
    }
  },
  mounted () {
    // this.getEvent()
  },
  methods: {
    async getEvent () {
      let self = this
      await self.getData(self.planData)
      await self.getData(self.bookData)
      await self.getData(self.bookData2)
      await self.getData(self.bookData3)
      await self.getData(self.bookData4)
    },
    getData (itemData) {
      let self = this
      let pathArr = []
      for (let i = 0; i < itemData.length; i++) {
        pathArr.push(itemData[i].id)
      }
      axios.get(`/products?list=${pathArr.toString()}&pageSize=20`)
        .then((response) => {
          response.data.data.map(item1 => {
            itemData.map(item2 => {
              if (item1.id === item2.id) {
                return Object.assign(item2, item1)
              }
            })
          })
        })
        .then(() => {
          self.forceRerender()
        })
    },
    forceRerender () {
      this.renderComponent = false
      this.$nextTick(() => {
        this.renderComponent = true
      })
    },
    toTop (n) {
      jump(`${n}`, {
        duration: 500,
        offset: 0
      })
    }
  }
}
</script>
<style lang="scss" scoped>
#Sep2023 {
  .outer {
    position: relative;
    width: 100%;
    display: block;
    &:after {
      content: "";
      display: block;
      padding-Bottom: 100%;
    }
    .inner {
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .main-bg {
    background-color: #FECB4E;
  }
  .second-bg {
    background-color: #FDEAA8;
  }
  .dot-bg {
    background-image: url('~@/assets/images/202309/source_main-bg.png');
    background-repeat: true;
    background-size: contain;
  }
  .section2 {
    .section2_sale {
      left: -4%;
      top: -8%;
      width: 9%;
    }
  }
  .section3 {
    .p1 {
      top: 0%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 20em;
    }

    .p2 {
      width: 15%;
      right: -3%;
      top: -3%;
    }

    .p3 {
      width: 15%;
      right: -3%;
      bottom: 3%;
    }
  }
  .section6 {
    .p1 {
      top: 0%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 20em;
    }
  }
  .section8 {
    .p4 {
      width: 23%;
      left: -4%;
      top:50%;
      transform: translateY(-50%);
    }
  }
  // .section1 {
  //   background-image: url('~@/assets/images/202309/source_main-bg.png');
  //   background-repeat: true;
  //   background-size: contain;
  // }
}
</style>
